import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { StorySection } from './components/StorySection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { AudienceSection } from './components/AudienceSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-bakery-cream font-sans selection:bg-bakery-amber selection:text-bakery-brown" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <StorySection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <IncludesSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <ProofSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}